import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-7">
      {categories.map((cat) => (
        <a
          key={cat.id}
          href={cat.url}
          target="_blank"
          rel="noopener nofollow"
          className="group flex flex-col items-center gap-3 rounded-xl border border-background-200/70 bg-white p-5 transition-all hover:-translate-y-0.5 hover:border-primary-300 hover:shadow-sm cursor-pointer"
        >
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-background-100 text-foreground-500 transition-colors group-hover:bg-primary-50 group-hover:text-primary-600">
            <i className={`${cat.icon} text-xl`}></i>
          </span>
          <span className="text-center text-xs font-medium text-foreground-700 group-hover:text-foreground-900">
            {t(`categories.${cat.id}`, cat.name)}
          </span>
        </a>
      ))}
    </div>
  );
}